import React, { Component } from 'react';
import { Row, Alert, Modal } from 'antd';
import { Auth, Billing } from '../../../../services/api';
import { Elements, StripeProvider } from 'react-stripe-elements';
import CheckoutForm from '../../../../components/CheckoutForm';
import TokenStorage from '../../../../services/TokenStorage';

export default class Payment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            billing: {},
            loading: false,
            cardValid: false
        };

        this.billingApi = new Billing();
        this.authApi = new Auth(props);
    }

    componentDidMount() {
        this.fetchBilling();
    }

    fetchBilling = () => {
        this.billingApi.details()
            .then(res => {
                this.setState({ billing: res.data.data });
            })
            .catch(() => {
                this.billingApi.retry({ cb: this.fetchBilling });
            });
    }

    handleOk = () => {
        const token = TokenStorage.getToken(TokenStorage.TYPE_REFRESH);
        this.authApi.refresh(token)
            .then(res => {
                TokenStorage.setToken(TokenStorage.TYPE_ID, res.data.data.id_token);
                TokenStorage.setToken(TokenStorage.TYPE_REFRESH, res.data.data.refresh_token);
                this.props.history.push('/menus');
            })
            .catch(() => {
                this.logout();
            });
    }

    handleCancel = () => {
        this.authApi.logout()
            .then(() => {
                TokenStorage.removeToken(TokenStorage.TYPE_ID);
                TokenStorage.removeToken(TokenStorage.TYPE_REFRESH);
                this.props.history.push('/');
            })
            .catch(() => {
                TokenStorage.removeToken(TokenStorage.TYPE_ID);
                TokenStorage.removeToken(TokenStorage.TYPE_REFRESH);
                this.props.history.push('/');
            });
    }

    handleSuccess = () => {
        this.setState({ cardValid: true, loading: false })
        this.handleOk();
    }

    render() {
        const { cardValid, loading, billing } = this.state;
        
        return (
            <Row>
                <Modal
                    title="Ange betalinformation"
                    visible={true}
                    closable={false}
                    maskClosable={false}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okButtonProps={{ disabled: !cardValid, loading: loading }}
                    cancelButtonProps={{ disabled: cardValid }}
                    cancelText="Avbryt"
                >
                    <Alert
                        type="info"
                        message={(
                            <div>
                                {billing.has_card && (
                                    <div>
                                        <p>Din senatse betalning misslyckades.</p>
                                        <p>Var vänlig ange dina kortuppgifter nedan för att fortsätta använda tjänsten.</p>
                                        <p>Ditt kort kommer debiteras med: <strong>199 kr/månad.</strong></p>
                                    </div>
                                )}
                                {!billing.has_card && (
                                    <div>
                                        <p>Innan du kan komma igång måste du ange giltig betalinformation.</p>
                                        <p>De första 14 dagarna bjuder vi på, efter det kommer ditt kort debiteras med: <strong>199 kr/månad.</strong></p>
                                        <p>Du kan när som helst avsluta ditt konto under testperioden, utan någon kostnad.</p>
                                    </div>
                                )}
                            </div>)}
                        showIcon
                        style={{ marginBottom: '20px' }}
                     />
                     {cardValid && (
                        <Alert
                            type="success"
                            message="Din betalinformation har lagts till. Du kan nu börja använda ditt konto."
                            showIcon
                            style={{ marginBottom: '20px' }}
                        />  
                     )}
                    <StripeProvider apiKey="pk_test_ZPdN66V614YGjyhg4rQP8I87" locale="se">
                        <Elements locale="sv">
                            <CheckoutForm onSuccess={this.handleSuccess} onLoading={() => this.setState({ loading: true })} onError={() => this.setState({ loading: false })} />
                        </Elements>
                    </StripeProvider>
                </Modal>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/components/profile/Payment.js